import { sendEvents } from '@fiverr-private/futile/lib/send/sendEvents';
import { bigQuery } from '@fiverr-private/obs';

/**
 * Sends event to BQ.
 * If Fiverr.sendClientEvents exists globally, will send with futile, else with obs.
 * @param {Object} data - to send to BigQuery.
 */
export default function sendEventWrapped(data) {
    if (typeof Fiverr === 'object' && typeof Fiverr.sendClientEvents === 'function') {
        sendEvents(data);
    } else {
        bigQuery.send(data);
    }
}
